import React, { Component, useEffect, useState } from 'react';
import * as d3 from "d3";
import havana from '../../../../../../data/havana';

class Variant extends React.Component {
    constructor(props) {
      super(props);
      this.state = {value: ''};
      this.type = 'variant'
  
      this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }
  
    handleChange(event) {
      this.setState({value: event.target.value});
    }
  
    handleSubmit(event) {
        event.preventDefault();

        var locusString = this.state.value,
            locusArray = []

        if (locusString.includes(':')) locusArray = locusString.split(':')
        else if (locusString.includes('_')) locusArray = locusString.split('_');

        const chromosome = +locusArray[0],
            position = +locusArray[1]

        const slotSize = 100000,
            slotLow = position-slotSize/2,
            slotHigh = position+slotSize/2,
            locusSize = this.props.locusSize;

        const newSlot = {
            chr: chromosome,
            low: slotLow,
            high: slotHigh,
        }

        function defineLocusLow (position) {
            const locusLow = position-locusSize/2;
            if (locusLow > slotLow) return locusLow
            else return slotLow
        }
        function defineLocusHigh (position) {
            const locusHigh = position+locusSize/2;
            if (locusHigh < slotHigh) return locusHigh
            else return slotHigh
        }

        const newLocus = {
            chr: chromosome,
            pos: position,
            low: defineLocusLow(position),
            high: defineLocusHigh(position),
        }

        this.props.setSlot(newSlot);
        this.props.setLocus(newLocus);
    }
  
    render() {
      return (
            <div
                className={this.state.value ? 'box boxActive' : 'box'}
                style={{margin: '12px 0 24px 0', justifyContent: 'center', width: 'auto'}}
                >
                <form onSubmit={this.handleSubmit}>
                    <input 
                        className="tabInput"
                        type="text" 
                        value={this.state.value} 
                        onChange={this.handleChange} 
                        placeholder={this.props.emptySpace}
                        />
                    <input 
                        id="b_variantSearch"
                        type="submit" 
                        value="Inspect variant" 
                        />
                </form>
            </div>
      );
    }
  }

  export default Variant

